// import wx from 'weixin-js-sdk';
import wx from '@tencent/ppd-base-libs/wx/wx-sdk';

/**
 * jsapi初始化
 * @param  {[type]} wxConfig [description]
 * @return {[type]}          [description]
 */
function init(wxConfig) {
  return new Promise((resolve, reject) => {
    const wxConfigInfo = {
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: wxConfig.appId, // 必填，公众号的唯一标识
      timestamp: wxConfig.timestamp, // 必填，生成签名的时间戳
      nonceStr: wxConfig.nonceStr, // 必填，生成签名的随机串
      signature: wxConfig.signature, // 必填，签名
      jsApiList: wxConfig.jsApiList, // 必填，需要使用的JS接口列表
    };

    wx.config(wxConfigInfo);

    let fail = false;
    let isTimeout = false;
    let timeout: any = 0;

    // 如果失败，wx.err, wx.ready的回调都会执行（从现象来看，是wx.error先执行），所以加一个fail作为flag，如果失败，就不执行resolve
    wx.ready(() => {
      if (isTimeout) {
        return;
      }
      clearTimeout(timeout);
      if (!fail) {
        resolve(true);
      }
    });

    wx.error((res) => {
      if (isTimeout) {
        return;
      }
      clearTimeout(timeout);
      fail = true;
      reject(res.errMsg);
    });

    // 超时处理，在浏览器访问会触发
    timeout = setTimeout(() => {
      isTimeout = true;
      reject('jsapi init timeout');
    }, 5000);
  });
}

const getOsType = () => {
  const ua = navigator.userAgent.toLowerCase();
  const matches = ua.match(/iphone|ipad|android/g);
  if (matches && matches.length) {
      return matches[0];
  } else {
      return 'other';
  }
};
/**
 * @description 拉起支付中心
 * @param  {...any} args
 */
function getH5PrepayRequest(args) {
  return new Promise((resolve) => {
    // @ts-ignore
    wx.ready(() => {
      // @ts-ignore
      WeixinJSBridge.invoke('getH5PrepayRequest', args, (res) => {
        try {
          const errMsg = res.err_msg || res.errMsg;
          if (-1 !== errMsg.indexOf('ok')) {
            const osType = getOsType();
            if ('android' === osType) {
              wx.closeWindow();
            }
          }
        } catch (e) {
          // do nothing
        }

        resolve(res);
      });
    });
    wx.error((err) => {
      console.log('wx error');
      console.log(err);
    });
  }).catch((err) => {
    console.log('promise error');
    console.log(err);
  });
}

/**
 * 拉起扫一扫
 */
function scanQRCode(args) {
  return new Promise((resolve) => {
    // @ts-ignore
    wx.ready(() => {
      // @ts-ignore
      WeixinJSBridge.invoke('scanQRCode', args, (res) => {
        const errMsg = res.err_msg || res.errMsg;

        resolve(res);
      });
    });
    wx.error((err) => {
      console.log('error', err);
    });
  }).catch((error) => {
    console.log('catch', error);
  });
}


export default {
  init,
  getH5PrepayRequest,
  scanQRCode,
};
